export default __webpack_public_path__ + "static/media/63.6a580294.svg";